import { useMutation, useQuery } from "react-query"
import { ListRegistryUsersDto } from "types/dto/ListRegistryUsersDto"
import * as registryUsersService from 'services/registryUsersService';


export const useGetRegistryUsers = (dto: ListRegistryUsersDto, options = {}) => {
  return useQuery({
    queryKey: ['registryUsers', dto],
    queryFn: () => registryUsersService.getRegistryUsers(dto),
    ...options,
  })
}

export const useRevokeRegistryUser = (onSuccess: any, onError: any) => {
  return useMutation(registryUsersService.RevokeRegistryUser, {
    onSuccess,
    onError
  });
}